import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'

import Section from 'components/Section'
import dataActions from 'actions/dataActions'

import { dirtyRead, doc } from 'selectors/common'

let select = dirtyRead(
	(state, props) => {
		return {
			owner: doc(state, props.ownerID)
		}
	}
)

export class AdditionalInfo extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="account-info"
				title="Additional info"
				top={true}
			>
				<TextField
					floatingLabelText="Address"
					defaultValue={props.owner.address}
					fullWidth={true}
					onBlur={(evt) => {
						props.STAGE({
							_id: props.ownerID
						  , address: evt.target.value
						})
					}}
				/>
				<TextField
					floatingLabelText="IIN"
					defaultValue={props.owner.iin}
					fullWidth={true}
					onBlur={(evt) => {
						props.STAGE({
							_id: props.ownerID
						  , iin: evt.target.value
						})
					}}
				/>
				<TextField
					floatingLabelText="Tax bracket"
					defaultValue={props.owner.taxBracket}
					fullWidth={true}
					onBlur={(evt) => {
						props.STAGE({
							_id: props.ownerID
						  , taxBracket: evt.target.value
						})
					}}
					autoFocus={props.query.taxDeferral}
				/>
			</Section>
		)
	}
}

export default connect(select, dataActions)(AdditionalInfo)



// WEBPACK FOOTER //
// ./src/routes/landlord/profile/AdditionalInfo.js